export const settingConstants = {
    GETALL_TZ_REQUEST: "TIMEZONES_GETALL_REQUEST",
    GETALL_TZ_SUCCESS: "TIMEZONES_GETALL_SUCCESS",
    GETALL_TZ_FAILURE: "TIMEZONES_GETALL_FAILURE",

    GETALL_USER_REQUEST: "USER_GETALL_REQUEST",
    GETALL_USER_SUCCESS: "USER_GETALL_SUCCESS",
    GETALL_USER_FAILURE: "USER_GETALL_FAILURE",

    CHANGE_SETTINGS_REQUEST: "CHANGE_SETTINGS_REQUEST",
    CHANGE_SETTINGS_SUCCESS: "CHANGE_SETTINGS_SUCCESS",
    CHANGE_SETTINGS_FAILURE: "CHANGE_SETTINGS_FAILURE",

    GET_CHANNEL_LIST_REQUEST: "SETTINGS_GET_CHANNEL_LIST_REQUEST",
    GET_CHANNEL_LIST_SUCCESS: "SETTINGS_GET_CHANNEL_LIST_SUCCESS",
    GET_CHANNEL_LIST_FAILURE: "SETTINGS_GET_CHANNEL_LIST_FAILURE",

    GET_SLA_CALENDER_LIST_REQUEST: "SETTINGS_GET_SLA_CALENDER_LIST_REQUEST",
    GET_SLA_CALENDER_LIST_SUCCESS: "SETTINGS_GET_SLA_CALENDER_LIST_SUCCESS",
    GET_SLA_CALENDER_LIST_FAILURE: "SETTINGS_GET_SLA_CALENDER_LIST_FAILURE",

    GET_PLATFORM_LIST_REQUEST: "SETTINGS_GET_PLATFORM_LIST_REQUEST",
    GET_PLATFORM_LIST_SUCCESS: "SETTINGS_GET_PLATFORM_LIST_SUCCESS",
    GET_PLATFORM_LIST_FAILURE: "SETTINGS_GET_PLATFORM_LIST_FAILURE"
};